<app-sling-siren-alert-config *ngIf="isSling"></app-sling-siren-alert-config>
<app-movement-siren-alert-config *ngIf="isMovement"></app-movement-siren-alert-config>
